export default [
    {
        "error_id": "T-XS-01",
        "data": [
            {
                "cross_section": "11791",
                "dsrl": 519.64,
                "headloss": 2.12,
                "conv_ratio": 1.88,
                "vel_head": 1.35
            },
            {
                "cross_section": "4639",
                "dsrl": 502.12,
                "headloss": 2.28,
                "conv_ratio": 1.26,
                "vel_head": 0.76
            }
        ]
    },
    {
        "error_id": "XS-02",
        "data": [
            {
                "cross_section": "18856",
                "profile": "100yr (1%)",
                "headloss": 4.46
            },
            {
                "cross_section": "18433",
                "profile": "100yr (1%)",
                "headloss": 7.42
            },
            {
                "cross_section": "17632",
                "profile": "100yr (1%)",
                "headloss": 7.1
            },
            {
                "cross_section": "16758",
                "profile": "100yr (1%)",
                "headloss": 1.87
            },
            {
                "cross_section": "16179",
                "profile": "100yr (1%)",
                "headloss": 1.9
            },
            {
                "cross_section": "14833",
                "profile": "100yr (1%)",
                "headloss": 1.13
            },
            {
                "cross_section": "14598",
                "profile": "100yr (1%)",
                "headloss": 3.76
            },
            {
                "cross_section": "14198",
                "profile": "100yr (1%)",
                "headloss": 3.55
            },
            {
                "cross_section": "13807",
                "profile": "100yr (1%)",
                "headloss": 1.22
            },
            {
                "cross_section": "13326",
                "profile": "100yr (1%)",
                "headloss": 3.04
            },
            {
                "cross_section": "12200",
                "profile": "100yr (1%)",
                "headloss": 1.5
            },
            {
                "cross_section": "11791",
                "profile": "100yr (1%)",
                "headloss": 2.12
            },
            {
                "cross_section": "11272",
                "profile": "100yr (1%)",
                "headloss": 1.56
            },
            {
                "cross_section": "9946    BR U #1",
                "profile": "100yr (1%)",
                "headloss": 4.59
            },
            {
                "cross_section": "9586",
                "profile": "100yr (1%)",
                "headloss": 2.07
            },
            {
                "cross_section": "9070",
                "profile": "100yr (1%)",
                "headloss": 1.81
            },
            {
                "cross_section": "8551",
                "profile": "100yr (1%)",
                "headloss": 1.2
            },
            {
                "cross_section": "8015",
                "profile": "100yr (1%)",
                "headloss": 1.91
            },
            {
                "cross_section": "6751",
                "profile": "100yr (1%)",
                "headloss": 1.84
            },
            {
                "cross_section": "6497",
                "profile": "100yr (1%)",
                "headloss": 2.19
            },
            {
                "cross_section": "6300",
                "profile": "100yr (1%)",
                "headloss": 1.59
            },
            {
                "cross_section": "4639",
                "profile": "100yr (1%)",
                "headloss": 2.28
            },
            {
                "cross_section": "4137",
                "profile": "100yr (1%)",
                "headloss": 3.18
            },
            {
                "cross_section": "1540",
                "profile": "100yr (1%)",
                "headloss": 1.62
            },
            {
                "cross_section": "1238",
                "profile": "100yr (1%)",
                "headloss": 1.04
            },
            {
                "cross_section": "906",
                "profile": "100yr (1%)",
                "headloss": 1.13
            },
            {
                "cross_section": "661",
                "profile": "100yr (1%)",
                "headloss": 1.62
            },
            {
                "cross_section": "453",
                "profile": "100yr (1%)",
                "headloss": 1.16
            },
            {
                "cross_section": "285",
                "profile": "100yr (1%)",
                "headloss": 1.05
            },
            {
                "cross_section": "123",
                "profile": "100yr (1%)",
                "headloss": 1.2
            }
        ]
    },
    {
        "error_id": "XS-03",
        "data": [
            {
                "cross_section": "18856",
                "profile": "100yr (1%)",
                "conv_ratio": 1.12
            },
            {
                "cross_section": "18433",
                "profile": "100yr (1%)",
                "conv_ratio": 0.81
            },
            {
                "cross_section": "17632",
                "profile": "100yr (1%)",
                "conv_ratio": 1.06
            },
            {
                "cross_section": "16758",
                "profile": "100yr (1%)",
                "conv_ratio": 0.45
            },
            {
                "cross_section": "16305",
                "profile": "100yr (1%)",
                "conv_ratio": 0.97
            },
            {
                "cross_section": "16266",
                "profile": "100yr (1%)",
                "conv_ratio": 2.15
            },
            {
                "cross_section": "16246   BR U",
                "profile": "100yr (1%)",
                "conv_ratio": 1.72
            },
            {
                "cross_section": "16246   BR D",
                "profile": "100yr (1%)",
                "conv_ratio": 0.5
            },
            {
                "cross_section": "16227",
                "profile": "100yr (1%)",
                "conv_ratio": 0.97
            },
            {
                "cross_section": "16179",
                "profile": "100yr (1%)",
                "conv_ratio": 1
            },
            {
                "cross_section": "15875",
                "profile": "100yr (1%)",
                "conv_ratio": 1.02
            },
            {
                "cross_section": "15606",
                "profile": "100yr (1%)",
                "conv_ratio": 0.69
            },
            {
                "cross_section": "15467",
                "profile": "100yr (1%)",
                "conv_ratio": 0.96
            },
            {
                "cross_section": "15412",
                "profile": "100yr (1%)",
                "conv_ratio": 2.19
            },
            {
                "cross_section": "15400   BR U",
                "profile": "100yr (1%)",
                "conv_ratio": 0.79
            },
            {
                "cross_section": "15400   BR D",
                "profile": "100yr (1%)",
                "conv_ratio": 0.53
            },
            {
                "cross_section": "15386",
                "profile": "100yr (1%)",
                "conv_ratio": 0.76
            },
            {
                "cross_section": "15350",
                "profile": "100yr (1%)",
                "conv_ratio": 0.82
            },
            {
                "cross_section": "14964",
                "profile": "100yr (1%)",
                "conv_ratio": 0.95
            },
            {
                "cross_section": "14913",
                "profile": "100yr (1%)",
                "conv_ratio": 5.16
            },
            {
                "cross_section": "14893   BR U",
                "profile": "100yr (1%)",
                "conv_ratio": 1.07
            },
            {
                "cross_section": "14893   BR D",
                "profile": "100yr (1%)",
                "conv_ratio": 0.38
            },
            {
                "cross_section": "14870",
                "profile": "100yr (1%)",
                "conv_ratio": 0.85
            },
            {
                "cross_section": "14833",
                "profile": "100yr (1%)",
                "conv_ratio": 1.72
            },
            {
                "cross_section": "14598",
                "profile": "100yr (1%)",
                "conv_ratio": 1.11
            },
            {
                "cross_section": "14198",
                "profile": "100yr (1%)",
                "conv_ratio": 0.89
            },
            {
                "cross_section": "13807",
                "profile": "100yr (1%)",
                "conv_ratio": 0.48
            },
            {
                "cross_section": "13468",
                "profile": "100yr (1%)",
                "conv_ratio": 1.27
            },
            {
                "cross_section": "13400",
                "profile": "100yr (1%)",
                "conv_ratio": 2.11
            },
            {
                "cross_section": "13387   BR U",
                "profile": "100yr (1%)",
                "conv_ratio": 1.38
            },
            {
                "cross_section": "13387   BR D",
                "profile": "100yr (1%)",
                "conv_ratio": 0.6
            },
            {
                "cross_section": "13370",
                "profile": "100yr (1%)",
                "conv_ratio": 0.98
            },
            {
                "cross_section": "13326",
                "profile": "100yr (1%)",
                "conv_ratio": 0.86
            },
            {
                "cross_section": "12916",
                "profile": "100yr (1%)",
                "conv_ratio": 0.39
            },
            {
                "cross_section": "12339",
                "profile": "100yr (1%)",
                "conv_ratio": 0.99
            },
            {
                "cross_section": "12274",
                "profile": "100yr (1%)",
                "conv_ratio": 1.54
            },
            {
                "cross_section": "12262   BR U",
                "profile": "100yr (1%)",
                "conv_ratio": 0.98
            },
            {
                "cross_section": "12262   BR D",
                "profile": "100yr (1%)",
                "conv_ratio": 0.7
            },
            {
                "cross_section": "12251",
                "profile": "100yr (1%)",
                "conv_ratio": 2.16
            },
            {
                "cross_section": "12200",
                "profile": "100yr (1%)",
                "conv_ratio": 0.65
            },
            {
                "cross_section": "11791",
                "profile": "100yr (1%)",
                "conv_ratio": 1.88
            },
            {
                "cross_section": "11272",
                "profile": "100yr (1%)",
                "conv_ratio": 0.57
            },
            {
                "cross_section": "11039",
                "profile": "100yr (1%)",
                "conv_ratio": 1.91
            },
            {
                "cross_section": "11022   BR U",
                "profile": "100yr (1%)",
                "conv_ratio": 1.42
            },
            {
                "cross_section": "11022   BR D",
                "profile": "100yr (1%)",
                "conv_ratio": 0.58
            },
            {
                "cross_section": "11009",
                "profile": "100yr (1%)",
                "conv_ratio": 0.77
            },
            {
                "cross_section": "10957",
                "profile": "100yr (1%)",
                "conv_ratio": 0.37
            },
            {
                "cross_section": "10516",
                "profile": "100yr (1%)",
                "conv_ratio": 0.63
            },
            {
                "cross_section": "10181",
                "profile": "100yr (1%)",
                "conv_ratio": 0.75
            },
            {
                "cross_section": "9946    BR U #1",
                "profile": "100yr (1%)",
                "conv_ratio": 1.15
            },
            {
                "cross_section": "9835",
                "profile": "100yr (1%)",
                "conv_ratio": 0.71
            },
            {
                "cross_section": "9693",
                "profile": "100yr (1%)",
                "conv_ratio": 4.82
            },
            {
                "cross_section": "9669    BR U",
                "profile": "100yr (1%)",
                "conv_ratio": 1.61
            },
            {
                "cross_section": "9669    BR D",
                "profile": "100yr (1%)",
                "conv_ratio": 0.58
            },
            {
                "cross_section": "9644",
                "profile": "100yr (1%)",
                "conv_ratio": 0.83
            },
            {
                "cross_section": "9586",
                "profile": "100yr (1%)",
                "conv_ratio": 0.91
            },
            {
                "cross_section": "9070",
                "profile": "100yr (1%)",
                "conv_ratio": 0.9
            },
            {
                "cross_section": "8551",
                "profile": "100yr (1%)",
                "conv_ratio": 1.04
            },
            {
                "cross_section": "8187",
                "profile": "100yr (1%)",
                "conv_ratio": 1.63
            },
            {
                "cross_section": "8057",
                "profile": "100yr (1%)",
                "conv_ratio": 1.38
            },
            {
                "cross_section": "8015",
                "profile": "100yr (1%)",
                "conv_ratio": 0.68
            },
            {
                "cross_section": "7705",
                "profile": "100yr (1%)",
                "conv_ratio": 0.57
            },
            {
                "cross_section": "7333",
                "profile": "100yr (1%)",
                "conv_ratio": 1.02
            },
            {
                "cross_section": "6991",
                "profile": "100yr (1%)",
                "conv_ratio": 1.99
            },
            {
                "cross_section": "6751",
                "profile": "100yr (1%)",
                "conv_ratio": 1.34
            },
            {
                "cross_section": "6497",
                "profile": "100yr (1%)",
                "conv_ratio": 1.08
            },
            {
                "cross_section": "6300",
                "profile": "100yr (1%)",
                "conv_ratio": 0.45
            },
            {
                "cross_section": "6016",
                "profile": "100yr (1%)",
                "conv_ratio": 0.7
            },
            {
                "cross_section": "5726",
                "profile": "100yr (1%)",
                "conv_ratio": 0.86
            },
            {
                "cross_section": "5030",
                "profile": "100yr (1%)",
                "conv_ratio": 2.15
            },
            {
                "cross_section": "4639",
                "profile": "100yr (1%)",
                "conv_ratio": 1.26
            },
            {
                "cross_section": "4137",
                "profile": "100yr (1%)",
                "conv_ratio": 1.62
            },
            {
                "cross_section": "3773",
                "profile": "100yr (1%)",
                "conv_ratio": 0.61
            },
            {
                "cross_section": "3415",
                "profile": "100yr (1%)",
                "conv_ratio": 0.4
            },
            {
                "cross_section": "3102",
                "profile": "100yr (1%)",
                "conv_ratio": 1.93
            },
            {
                "cross_section": "2650",
                "profile": "100yr (1%)",
                "conv_ratio": 0.62
            },
            {
                "cross_section": "2344",
                "profile": "100yr (1%)",
                "conv_ratio": 1.15
            },
            {
                "cross_section": "2092",
                "profile": "100yr (1%)",
                "conv_ratio": 1.37
            },
            {
                "cross_section": "1980",
                "profile": "100yr (1%)",
                "conv_ratio": 1.08
            },
            {
                "cross_section": "1892",
                "profile": "100yr (1%)",
                "conv_ratio": 0.53
            },
            {
                "cross_section": "1729",
                "profile": "100yr (1%)",
                "conv_ratio": 2.36
            },
            {
                "cross_section": "1540",
                "profile": "100yr (1%)",
                "conv_ratio": 0.8
            },
            {
                "cross_section": "1238",
                "profile": "100yr (1%)",
                "conv_ratio": 0.79
            },
            {
                "cross_section": "906",
                "profile": "100yr (1%)",
                "conv_ratio": 1.94
            },
            {
                "cross_section": "661",
                "profile": "100yr (1%)",
                "conv_ratio": 0.8
            },
            {
                "cross_section": "453",
                "profile": "100yr (1%)",
                "conv_ratio": 1.11
            },
            {
                "cross_section": "285",
                "profile": "100yr (1%)",
                "conv_ratio": 0.47
            },
            {
                "cross_section": "123",
                "profile": "100yr (1%)",
                "conv_ratio": 1
            }
        ]
    },
    {
        "error_id": "XS-04",
        "data": [
            {
                "cross_section": "16758",
                "profile": "100yr (1%)",
                "vel_head": 0.73
            },
            {
                "cross_section": "16179",
                "profile": "100yr (1%)",
                "vel_head": 0.63
            },
            {
                "cross_section": "15875",
                "profile": "100yr (1%)",
                "vel_head": 0.59
            },
            {
                "cross_section": "14913",
                "profile": "100yr (1%)",
                "vel_head": 0.78
            },
            {
                "cross_section": "14833",
                "profile": "100yr (1%)",
                "vel_head": 1.62
            },
            {
                "cross_section": "14598",
                "profile": "100yr (1%)",
                "vel_head": 0.93
            },
            {
                "cross_section": "14198",
                "profile": "100yr (1%)",
                "vel_head": 0.56
            },
            {
                "cross_section": "12916",
                "profile": "100yr (1%)",
                "vel_head": 0.7
            },
            {
                "cross_section": "12251",
                "profile": "100yr (1%)",
                "vel_head": 1.5
            },
            {
                "cross_section": "11791",
                "profile": "100yr (1%)",
                "vel_head": 1.35
            },
            {
                "cross_section": "11272",
                "profile": "100yr (1%)",
                "vel_head": 1.18
            },
            {
                "cross_section": "11039",
                "profile": "100yr (1%)",
                "vel_head": 0.93
            },
            {
                "cross_section": "10957",
                "profile": "100yr (1%)",
                "vel_head": 0.54
            },
            {
                "cross_section": "9946    BR D #1",
                "profile": "100yr (1%)",
                "vel_head": 0.64
            },
            {
                "cross_section": "9644",
                "profile": "100yr (1%)",
                "vel_head": 0.7
            },
            {
                "cross_section": "8187",
                "profile": "100yr (1%)",
                "vel_head": 0.78
            },
            {
                "cross_section": "8100",
                "profile": "100yr (1%)",
                "vel_head": 0.6
            },
            {
                "cross_section": "8015",
                "profile": "100yr (1%)",
                "vel_head": 1.08
            },
            {
                "cross_section": "6751",
                "profile": "100yr (1%)",
                "vel_head": 1.75
            },
            {
                "cross_section": "6497",
                "profile": "100yr (1%)",
                "vel_head": 0.83
            },
            {
                "cross_section": "6300",
                "profile": "100yr (1%)",
                "vel_head": 1.43
            },
            {
                "cross_section": "5030",
                "profile": "100yr (1%)",
                "vel_head": 0.96
            },
            {
                "cross_section": "4639",
                "profile": "100yr (1%)",
                "vel_head": 0.76
            },
            {
                "cross_section": "4137",
                "profile": "100yr (1%)",
                "vel_head": 0.81
            },
            {
                "cross_section": "3773",
                "profile": "100yr (1%)",
                "vel_head": 1.98
            },
            {
                "cross_section": "3415",
                "profile": "100yr (1%)",
                "vel_head": 0.57
            },
            {
                "cross_section": "1729",
                "profile": "100yr (1%)",
                "vel_head": 1.26
            },
            {
                "cross_section": "1540",
                "profile": "100yr (1%)",
                "vel_head": 0.61
            },
            {
                "cross_section": "906",
                "profile": "100yr (1%)",
                "vel_head": 1.99
            },
            {
                "cross_section": "453",
                "profile": "100yr (1%)",
                "vel_head": 0.88
            },
            {
                "cross_section": "285",
                "profile": "100yr (1%)",
                "vel_head": 1.77
            },
            {
                "cross_section": "226",
                "profile": "100yr (1%)",
                "vel_head": 2.95
            }
        ]
    },
    {
        "error_id": "XS-05",
        "data": [
            {
                "cross_section": "18433",
                "dsrl": 800.89
            },
            {
                "cross_section": "17632",
                "dsrl": 873.91
            },
            {
                "cross_section": "12916",
                "dsrl": 576.21
            },
            {
                "cross_section": "11791",
                "dsrl": 519.64,
                "headloss": 2.12,
                "conv_ratio": 1.88,
                "vel_head": 1.35
            },
            {
                "cross_section": "9586",
                "dsrl": 516.79
            },
            {
                "cross_section": "9070",
                "dsrl": 518.34
            },
            {
                "cross_section": "5726",
                "dsrl": 696.27
            },
            {
                "cross_section": "4639",
                "dsrl": 502.12,
                "headloss": 2.28,
                "conv_ratio": 1.26,
                "vel_head": 0.76
            }
        ]
    }
]